import styled from "styled-components";

export const ContactHeroWrapper = styled.div`
  background: ${(props) => props.theme.colors.purple_100};
  opacity: 0.9;
  padding: 8rem 0rem 6rem;
  @media screen and (max-width: 992px) {
    padding: 5rem;
  }
  @media screen and (max-width: 600px) {
    padding: 1rem;
  }
`;
